import axios from 'axios';
import { useEffect, useState } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import ReactPaginate from 'react-paginate';
import SearchBar from '../SearchBar';

// const BASE_URL = "http://localhost:8000";
const BASE_URL = "https://idealpursuits.co.in/api";

function SeminarBookings() {
    const [seminars, setSeminars] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 20;

    const fetchSeminars = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/getSeminarBookings.php`);
            setSeminars(response.data);
            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching seminars:', error);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchSeminars();
    }, []);

    const handleSearch = (value) => {
        setSearchTerm(value);
        setCurrentPage(0);
    };

    const filteredSeminars = seminars.filter((seminar) =>
        Object.values(seminar).some(
            (value) =>
                typeof value === 'string' && value.toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    const pageCount = Math.ceil(filteredSeminars.length / itemsPerPage);

    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected);
    };

    return (
        <div>
            <h2>Seminar Bookings</h2>
            <div className="search-bar">
                <SearchBar onSearch={handleSearch} />
            </div>
            {isLoading ? (
                <p>Loading seminars...</p>
            ) : (
                <div>
                    <table>
                        <thead>
                            <tr>
                                <th>User</th>
                                <th>Title</th>
                                <th>Date</th>
                                <th>Time</th>
                                <th>Booked on</th>
                                <th>Seminar Date</th>
                                <th>Seminar Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredSeminars
                                .slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage)
                                .map((seminar) => (
                                    <tr key={seminar.seminarBookingId}>
                                        <td>{seminar.userName}</td>
                                        <td>{seminar.title}</td>
                                        <td>{seminar.seminarDate}</td>
                                        <td>{seminar.seminarTime}</td>
                                        <td>{seminar.createdAt}</td>
                                        <td>{seminar.seminarDate}</td>
                                        <td>{seminar.seminarTime}</td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>

                    <ReactPaginate
                        previousLabel={<FaChevronLeft />}
                        nextLabel={<FaChevronRight />}
                        breakLabel={'...'}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageChange}
                        containerClassName={'pagination'}
                        activeClassName={'active'}
                        forcePage={currentPage}
                    />
                </div>
            )}
        </div>
    );
}

export default SeminarBookings;
